import React, {ReactElement} from "react";

import CTAButton, {CTA} from "../../buttons/cta-button/CTAButton";
import Icon from "../../icon/Icon";

import GetStartedSmallBg from "/src/svg/get-started-small.svg";

import {css, generateKeyId} from "/src/utils/utils";

import * as styles from "./widget-get-started.module.scss";

interface WidgetGetStartedProps {
  copy?: string;
  ctas?: Array<CTA>;
  headline?: string;
}

const WidgetGetStarted = (
  props: WidgetGetStartedProps
): ReactElement | null => {
  const {copy, ctas, headline} = props;

  if (!copy && !ctas && !headline) {
    return null;
  }

  return (
    <section className={css("widget-base", styles.widgetGetStarted)}>
      <Icon svg={GetStartedSmallBg} classes={styles.widgetGetStarted__iconBg} />

      {headline && (
        <h4 className={css("h4", styles.widgetGetStarted__headline)}>
          {headline}
        </h4>
      )}

      {copy && (
        <p className={css("p", styles.widgetGetStarted__copy)}>{copy}</p>
      )}

      {/* we will assume that the first CTA would be primary, subsequent cta should be secondary */}
      {ctas && (
        <ul className={css(styles.widgetGetStarted__ctas)}>
          {ctas.map((cta, i) => {
            const key = generateKeyId(
              `widget-get-started-cta-${cta.label}-${i}`
            );
            return (
              <li key={key} className={styles.widgetGetStarted__ctas__cta}>
                <CTAButton
                  key={key}
                  small
                  darkMode
                  kind={i === 0 ? "primary" : "secondary"}
                  cta={cta}
                />
              </li>
            );
          })}
        </ul>
      )}
    </section>
  );
};

export default WidgetGetStarted;
